import React from "react";

import { Header } from "../Shared";
import { PupilTable } from "./";

const PupilProgressTable = () => {

  return (
    <div className="Page-layout">
      <div className="Page-header">
        <Header />
        <div style={{ marginTop: "90px" }}>
          <PupilTable />
        </div>
      </div>
    </div>
  );
}

export { PupilProgressTable };